module.exports = __webpack_public_path__ + "img/monitoIcon.8aa6fe95.png";